import * as moment from 'moment';

export function getCandidateAge(birthDate: string): number {
  if (!moment(new Date(birthDate)).isValid()) {
    return -1;
  }

  return moment(new Date()).diff(moment(new Date(birthDate)), 'years');
}
